import type { AppointmentsFeatureConfig } from './type';

export const appointments: Partial<AppointmentsFeatureConfig> = {
    fetchHomeBranchById: true,
    timeslotsIntervalInDays: 31,
    filterBranchesBasedOnSelectedChannel: true,
};
